import React, { useState } from "react";
import ReactMarkdown from 'react-markdown';

// const API_BASE = "https://spanner-rag-backend-oa24ximoaa-uc.a.run.app";

const API_BASE = "https://spanner-rag-backend-198925083406.us-central1.run.app";
// UPDATED QUESTION GROUPS BASED ON YOUR LATEST UPDATE
const questionCategories = {
  "Demo Scenarios": [
    "What's the upgrade path from the ChromaJet Pro?",
    "I am looking for a beginner drone, and its parts and bundles information. Please give me some recommendations.",
    "I am setting up a home office and buying the ErgoFlex Pro Monitor Arm. What accessories are available to keep my desk tidy?"
  ]
};

function App() {
  const [query, setQuery] = useState("");
  const [ragAnswer, setRagAnswer] = useState("");
  const [graphAnswer, setGraphAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSelectQuestion = (e) => {
    const value = e.target.value;
    if (value) {
      setQuery(value);
    }
  };

  const askQuestion = async () => {
    setLoading(true);
    setError(null);
    setRagAnswer("");
    setGraphAnswer("");

    const fetchRag = async () => {
      try {
        const res = await fetch(`${API_BASE}/query/rag`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query })
        });
        if (!res.ok) throw new Error("Backend returned an error for RAG");
        const data = await res.json();
        setRagAnswer(data.answer || data.error || "No Traditional RAG response.");
      } catch (err) {
        console.error("RAG fetch error:", err);
        setRagAnswer("⚠️ Traditional RAG failed to load.");
      }
    };

    const fetchGraph = async () => {
      try {
        const res = await fetch(`${API_BASE}/query/graph`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query })
        });
        if (!res.ok) throw new Error("Backend returned an error for Graph RAG");
        const data = await res.json();
        setGraphAnswer(data.answer || data.error || "No Graph RAG response.");
      } catch (err) {
        console.error("Graph fetch error:", err);
        setGraphAnswer("⚠️ Graph RAG failed to load.");
      }
    };

    await Promise.all([fetchRag(), fetchGraph()]);
    setLoading(false);
  };

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        maxWidth: 1200,
        margin: "auto",
        padding: "2rem"
      }}
    >

      {/* LOGOS */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          marginBottom: "20px",
          alignItems: "center"
        }}
      >
        <img
          src="/images/spanner.png"
          alt="Spanner Logo"
          style={{ height: 60 }}
        />
        <img
          src="/images/googlecloud.png"
          alt="Google Cloud Logo"
          style={{ height: 60 }}
        />
      </div>

      <h1 style={{ textAlign: "center" }}>Graph-RAG Comparison</h1>

      {/* CATEGORY DROPDOWN */}
      <select
        onChange={handleSelectQuestion}
        style={{
          width: "100%",
          padding: 10,
          marginBottom: 15,
          borderRadius: 6,
          border: "1px solid #ccc",
          fontSize: "1rem"
        }}
      >
        <option value="">Choose a suggested question…</option>

        {Object.entries(questionCategories).map(([category, questions]) => (
          <optgroup key={category} label={category}>
            {questions.map((q, idx) => (
              <option key={idx} value={q}>
                {q}
              </option>
            ))}
          </optgroup>
        ))}
      </select>

      {/* TEXT INPUT */}
      <textarea
        rows={3}
        style={{
          width: "100%",
          fontSize: "1rem",
          borderRadius: 6,
          border: "1px solid #ccc",
          padding: 10
        }}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Ask a question..."
      />

      <div style={{ textAlign: "center", marginTop: 10 }}>
        <button
          onClick={askQuestion}
          disabled={loading || !query}
          style={{
            background: query ? "#4CAF50" : "#9E9E9E",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: 5,
            cursor: query ? "pointer" : "not-allowed"
          }}
        >
          {loading ? "Thinking..." : "Ask"}
        </button>
      </div>

      {error && (
        <div
          style={{
            color: "#b00020",
            background: "#ffe6e6",
            padding: 10,
            borderRadius: 5,
            marginTop: 20
          }}
        >
          {error}
        </div>
      )}

      {/* RESULTS SECTION */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 30,
          gap: "20px"
        }}
      >
        {/* TRADITIONAL RAG PANEL */}
        <div
          style={{
            flex: 1,
            background: "#f9f9f9",
            padding: 20,
            borderRadius: 8,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}
        >
          <h2>Traditional RAG</h2>
          <div style={{ fontSize: "16px", lineHeight: "1.6" }}>
            {ragAnswer ? <ReactMarkdown>{ragAnswer}</ReactMarkdown> : (loading && "Loading Traditional RAG answer...")}
          </div>
        </div>

        {/* GRAPH RAG PANEL */}
        <div
          style={{
            flex: 1,
            background: "#f9f9f9",
            padding: 20,
            borderRadius: 8,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}
        >
          <h2>Graph RAG</h2>
          <div style={{ fontSize: "16px", lineHeight: "1.6" }}>
            {graphAnswer ? <ReactMarkdown>{graphAnswer}</ReactMarkdown> : (loading && "Loading Graph RAG answer...")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
